import { injectable } from '@servicetitan/react-ioc';
import { CancelToken } from 'axios';

import { HttpClient } from './http-client';
import { BaseRequestModel } from '../models/base-request.model';
import { getBaseRequestParams } from '../utils/base-request-params';

export enum TopicType {
    InformationInServiceTitan = 1,
    EquipmentInformation = 2,
    Troubleshooting = 3,
    FieldProCoaching = 4,
}

export interface TopicApiModel {
    id: number;
    type: TopicType;
    name: string;
    description: string;
    message?: string;
    disabled?: boolean;
}

export interface TopicsResponse {
    topics: TopicApiModel[];
}

@injectable()
export class TopicsApi {
    constructor(private readonly httpClient: HttpClient) {}

    getTopics = (cancellationToken?: CancelToken) => {
        return this.httpClient.post<TopicsResponse, BaseRequestModel>(
            '/api/v1/topics',
            { ...getBaseRequestParams() },
            {
                cancelToken: cancellationToken,
            }
        );
    };
}
